import { api } from "@/lib/api";
import {
  CreateHotel,
  createHotelToDto,
  Hotel,
  HotelDtoSchema,
  hotelFromDto,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getHotelsQueryOptions } from "./get.hooks";

export function useCreateHotel(opts?: {
  onSuccess?: (hotel: Hotel) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (hotel: CreateHotel) => {
      const dto = createHotelToDto(hotel);
      const result = await api.post("/api/hotels", dto, HotelDtoSchema);
      return hotelFromDto(result);
    },
    onSuccess: (hotel) => {
      queryClient.setQueryData(getHotelsQueryOptions.queryKey, (old) => [
        ...(old ?? []),
        hotel,
      ]);
      toast({
        title: "toast.hotelCreated",
        variant: "success",
      });
      opts?.onSuccess?.(hotel);
    },
    onError: () => {
      toast({
        title: "toast.createHotelError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
